import { createFeature, createReducer, on } from '@ngrx/store';

import { BusinessEntitiesActions } from './business-entities.actions';
import { BusinessEntityDto } from './models/business-entities.model';

export interface BusinessEntitiesState {
  error: string | null;
  loading: boolean;
  businessEntities: BusinessEntityDto[];
}

export const initialState: BusinessEntitiesState = {
  error: null,
  loading: false,
  businessEntities: [],
};

const reducer = createReducer(
  initialState,
  on(BusinessEntitiesActions.getBusinessEntities, (state) => ({ ...state, loading: true })),
  on(BusinessEntitiesActions.loadSuccess, (state, { businessEntities }) => ({
    ...state,
    businessEntities: businessEntities?.map((be) => ({ ...be })) ?? [],
    loading: false,
  })),
  on(BusinessEntitiesActions.loadFailure, (state, { error }) => ({
    ...state,
    error: String(error),
    loading: false,
  })),
);

export const businessEntitiesFeature = createFeature({
  name: 'businessEntities',
  reducer,
});
